import {createSvgIcon} from '../create-svg-icon';

export const TitleIcon = createSvgIcon(
  <path d="M5 4v3h5.5v12h3V7H19V4H5z" />
, 'TitleOutlined');
